"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiographySummary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const DriversLicenses_1 = require("./components/DriversLicenses");
const Employment_1 = require("./components/Employment");
const Experience_1 = require("./components/Experience");
const JournalSystems_1 = require("./components/JournalSystems");
const LicenseStatuses_1 = require("./components/LicenseStatuses");
const elements_1 = require("../../../elements");
const Summary = (0, styled_1.default)(elements_1.Flex)({
    // Hide the element if there's no content:
    ':not(:has(*))': {
        display: 'none',
    },
});
const BiographySummary = () => {
    return ((0, jsx_runtime_1.jsxs)(Summary, { col: true, gap: 2.5, styles: { maxWidth: 512, w: 'full' }, children: [(0, jsx_runtime_1.jsx)(Experience_1.Experience, {}), (0, jsx_runtime_1.jsx)(LicenseStatuses_1.LicenseStatuses, {}), (0, jsx_runtime_1.jsx)(JournalSystems_1.JournalSystems, {}), (0, jsx_runtime_1.jsx)(DriversLicenses_1.DriversLicenses, {}), (0, jsx_runtime_1.jsx)(Employment_1.Employment, {})] }));
};
exports.BiographySummary = BiographySummary;
